/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_internalBuyLinks = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SharedRespMoreWaysToBrowse_internalBuyLinks" | "SharedMobileMoreWaysToBrowse_internalBuyLinks">;
    readonly " $refType": "BuySharedMoreWaysToBrowse_internalBuyLinks";
}>;
export type BuySharedMoreWaysToBrowse_internalBuyLinks$data = BuySharedMoreWaysToBrowse_internalBuyLinks;
export type BuySharedMoreWaysToBrowse_internalBuyLinks$key = ReadonlyArray<{
    readonly " $data"?: BuySharedMoreWaysToBrowse_internalBuyLinks$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_internalBuyLinks">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedMoreWaysToBrowse_internalBuyLinks",
  "type": "InternalBuyLinkType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedMobileMoreWaysToBrowse_internalBuyLinks",
      "args": null
    }
  ]
};
(node as any).hash = '2509a5d91605340d03e6f6f7faa4c103';
export default node;
